import React from "react"
import DataTable from "react-data-table-component"
import ProductImage from "../../../../assets/images/product-image-headphones.png"
import { Input } from "reactstrap"

const SelectProduct = () => {

  const data = [
    {
      product: { productImage: ProductImage, name: "Blue Colored Headphones", productId: "346473", stock: "500" },
      price: 35.0,
      paymentMethod: "COD",
    },
    {
      product: { productImage: ProductImage, name: "Blue Colored Headphones", productId: "346473", stock: "500" },
      price: 50.0,
      paymentMethod: "Master Card",
    },
  ]

  const columns = [
    {
      name: "Products",
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-between gap-2 my-2">
          <div>
            <img src={row.product.productImage} width={58} height={55} alt="" />
          </div>
          <div>
            <div>{row.product.name}</div>
            <div>
              <span>Product ID:</span>
              <span className="ms-2">{row.product.productId}</span>
            </div>
            <div>
              <span>Stock:</span>
              <span className="ms-2">{row.product.stock}</span>
            </div>
          </div>
        </div>
      ),
    },
    { name: "Price", selector: (row) => row.price },
    { name: "Payment Method", selector: (row) => row.paymentMethod },
  ]

  const customStyles = {
    table: {
      style: {
        border: "1px solid #D9D9D9",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#F2F2F2",
      },
    },
  }


  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="fw-medium">
          <span>Selected Items:</span> <span>1</span>
        </div>
        <div>
          <Input type="text" placeholder="Search" />
        </div>
      </div>

      <DataTable data={data} columns={columns} selectableRows customStyles={customStyles} />
    </>
  )
}

export default SelectProduct
